<template>
    <modal
        v-if="statusModalMap"
        :key="'modal_map'"
    >
        <template v-slot:content>
            <div class="content__container">
                <div class="modal_courier_map">
                    <span class="modal_courier_map_strip"></span>
                    <div class="modal_courier_map_container">
                        <span class="modal_courier_map_title">{{ titleRestaurant }}</span>
                        <div class="modal_courier_map_route">
                            <map_courier
                                :key="'map_courier'"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </modal>

</template>

<script>

import {screenSize} from "../../../mixins/screenSize";
import modal from "../../modal/Modal.vue";
import {touchEvent} from "../../../mixins/touchEvent";
import map_courier from "./MapCourier.vue";

export default {
    name: "modal_courier_map",
    props: {
        titleRestaurant: {
            type: String,

        }
    },
    components: {
        modal,
        map_courier,
    },
    mixins: [screenSize, touchEvent],
    data() {
        return {
            statusModalMap: true,
        }
    },
    methods: {
        touchStartEvent(){
            if(this.touchElementClass === 'content__container') {
                setTimeout(() => {
                    this.closeModalMap();
                }, 200);
            }
        },
        moveTouchDown() {
            this.closeModalMap();
        },
        closeModalMap() {
            this.statusModalMap = false;
        },

    },
    computed: {},
}
</script>
